import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RouteLoader, RouteRenderer} from 'shared';
import {Observable, Subscription} from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {delay, first} from 'rxjs/operators';
import {DxDataGridComponent} from 'devextreme-angular';

@Component({
  selector: 'app-tractors-history-messages',
  templateUrl: './tractors-history-messages.component.html',
  styleUrls: ['./tractors-history-messages.component.scss']
})
export class TractorsHistoryMessagesComponent implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  @Input()
  loader: RouteLoader;
  private loaderSub: Subscription;

  @Input()
  renderer: RouteRenderer;

  isLoading: boolean;
  ds: DataSource;
  store: ArrayStore;

  @Input()
  onResize: Observable<number[]>;
  private onResizeSub: Subscription;
  width = '100%';
  height = '100%';

  constructor() {
    this.store = new ArrayStore({
      data: [],
    });
    this.ds = new DataSource({
      paginate: false,
      store: this.store,
    });

    this.onRowClick = this.onRowClick.bind(this);
  }

  ngOnInit(): void {
    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      if (isLoading) {
        this.clean();
      } else {
        this.build();
      }
    });

    this.onResizeSub = this.onResize.subscribe((size) => {
      this.width = size[0] + 'px';
      this.height = size[1] + 'px';
      this.grid.instance.updateDimensions();
    });
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
    this.onResizeSub.unsubscribe();
  }

  private clean() {
    this.store.clear();
  }

  private build() {
    this.loader.route.data.forEach(d => {
      this.store.insert(d);
    });
    this.ds.reload();
  }

  onRowClick(e: any) {
    this.renderer.flyToPacket(e.data);
  }
}
